import { z } from 'zod';

/* 프로필 수정 폼 스키마 */

const CommonSchema = z.object({
  userName: z.string().min(1),
  email: z.string(),
  userType: z.string(),
  countryCode: z.string(),
  emailMarketingAgreement: z.boolean().optional(),
  phoneMarketingAgreement: z.boolean().optional(),
  phoneNumber: z.union([z.string().min(8).max(30), z.literal('')]).optional(),
});

const VerifiedSchoolSchema = z.object({
  standardCode: z.string(),
});

export const StudentEditSchema = CommonSchema.extend({
  schoolName: z.string().min(1),
  schoolType: z.string().optional(),
  schoolTypeCode: z.string(),
  schoolGrade: z.coerce.number(),
  schoolGradeCode: z.string().min(1),
  verifiedSchool: VerifiedSchoolSchema.nullable().optional(),
});

export const TeacherEditSchema = CommonSchema.extend({
  schoolName: z.string().min(1),
  schoolType: z.string().optional(),
  schoolTypeCode: z.string().min(1),
  schoolGrade: z.coerce.number(),
  schoolGradeCode: z.string().min(1),
  verifiedSchool: VerifiedSchoolSchema.nullable().optional(),
  verifiedPhoneNumber: z.string().optional(),
});

export const NormalEditSchema = CommonSchema.extend({
  verifiedPhoneNumber: z.string().optional(),
});

export const CompanyEditSchema = CommonSchema.extend({
  companyName: z.string().min(1),
  position: z.string().optional(),
  verifiedPhoneNumber: z.string().optional(),
});

export type StudentEditFormData = z.infer<typeof StudentEditSchema>;
export type TeacherEditFormData = z.infer<typeof TeacherEditSchema>;
export type NormalEditFormData = z.infer<typeof NormalEditSchema>;
export type CompanyEditFormData = z.infer<typeof CompanyEditSchema>;

export type ProfileEditFormData =
  | StudentEditFormData
  | TeacherEditFormData
  | NormalEditFormData
  | CompanyEditFormData;
